import type { ArtworkContentBlock } from "@eaf/contracts";
import { ArtworkContent } from "./artwork-content";

export function InspectionContent({ blocks }: { blocks: ArtworkContentBlock[] }) {
  if (!blocks.length) return <>—</>;
  return (
    <div className="inspection-document">
      <ArtworkContent blocks={blocks} />
    </div>
  );
}

export function ValueList({ value }: { value: string | null }) {
  if (!value) return <>—</>;
  const values = value
    .split(/[,;\n]+/)
    .map((part) => part.trim())
    .filter(Boolean);
  if (values.length <= 1) return <>{value}</>;
  return (
    <span className="inspection-values">
      {values.map((part, index) => (
        <span key={`${index}-${part}`}>{part}</span>
      ))}
    </span>
  );
}

export function StatusValue({
  value,
  trueLabel,
  falseLabel
}: {
  value: string | null;
  trueLabel: string;
  falseLabel: string;
}) {
  if (!value) return <>—</>;
  const normalized = value.trim().toLowerCase();
  const isTrue = normalized === "true";
  const isFalse = normalized === "false";
  const label = isTrue ? trueLabel : isFalse ? falseLabel : value;
  return (
    <span className={`inspection-status inspection-status--${isTrue ? "yes" : "no"}`}>{label}</span>
  );
}

export function MeasurementValue({ value }: { value: string | null }) {
  if (!value) return <>—</>;
  const measurement = value
    .trim()
    .replace(/\s*(?:"|″)\s*$/, "")
    .trim();
  return measurement ? <>{measurement} in.</> : <>—</>;
}

export function TextValue({ value }: { value: string | null }) {
  if (!value) return <>—</>;
  return (
    <span className="inspection-copy">
      {value
        .split(/\n+/)
        .filter(Boolean)
        .map((paragraph, index) => (
          <span key={`${index}-${paragraph}`}>{paragraph}</span>
        ))}
    </span>
  );
}
